import { render } from "./mailbox.vue?vue&type=template&id=28ade13e&scoped=true"
import script from "./mailbox.vue?vue&type=script&lang=js"
export * from "./mailbox.vue?vue&type=script&lang=js"

import "./mailbox.vue?vue&type=style&index=0&id=28ade13e&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ade13e"]])

export default __exports__